import { findParticipant } from './identity';

/**
 * Queue items keep `addedBy` as the Firebase uid. This helper is the only
 * path that turns that uid into user-facing copy, using the event's
 * participant list. Profiles stay owner-private; we never read users/{uid}.
 */
export function displayNameForAddedBy(addedBy, participants) {
  if (!addedBy || addedBy === 'system') return addedBy === 'system' ? 'Rhythmé' : 'Guest';

  const participant = findParticipant(participants, addedBy);
  const name = typeof participant?.name === 'string' ? participant.name.trim() : '';
  if (name && name !== addedBy) return name;
  return 'Guest';
}

export function formatAddedByLabel(addedBy, participants) {
  return `Added by: ${displayNameForAddedBy(addedBy, participants)}`;
}
